import React from 'react';
import './banner.css';

const Banner = () => {
	return (
        <div className="banner-container">
            <div className="banner m-auto">
                <p>We are currently looking for artists interested in recording a cast album for the show. If interested, please contact us below.</p>
            </div>
        </div>
    )
}

export default Banner;
